<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 500 500">
    <title>{{title}}</title>
    <circle r="250" cx="250" cy="250" :fill="fill"></circle>
    <polyline fill="none" stroke="white" stroke-width="40" :class="{'check':trigger}" points="122,263.5 202,341.5 378,158.5"/>
  </svg>
</template>

<script>
export default {
  name: "CheckMarkAnimation",
  props: {
    title: {
      type: String,
      default: 'Check',
    },
    trigger: {
      type: Boolean,
      required: true,
    },
    size: {
      type: Number,
      default: 500,
    },
    fill: {
      type: String,
      default: 'var(--green)',
    }
  },
}
</script>

<style scoped lang="scss">
.cls-1 {
  fill: var(--green);
}

.check {
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
  animation: dash 1.3s .5s linear forwards;
}

@keyframes dash {
  to {
    stroke-dashoffset: 0;
  }
}
</style>
